import lightbox from "lightbox2";

(function () {
  lightbox.option({
    showImageNumberLabel: false,
  });
})();
